let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ij9Di")).then(() => parcelRequire('90eyR'));